import { useEffect, useState } from "react";
import axios from "axios";
import PageHero from "@/components/PageHero";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Gallery = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/gallery`)
      .then((res) => setItems(res.data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="page-gallery">
      <SEO title="Gallery" description="A visual journey across the Gopi Gadhvi Group ecosystem." path="/gallery" />
      <PageHero eyebrow="A Visual Journey" heading="Gallery" intro="Moments, spaces and creations from across the Gopi Gadhvi Group ecosystem." />

      <section className="relative page-shell pb-28">
        {loading && (
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4" data-testid="gallery-loading">
            {Array.from({ length: 9 }).map((_, i) => (
              <div key={i} className="neu-surface aspect-square animate-pulse" />
            ))}
          </div>
        )}

        {!loading && error && (
          <div className="neu-panel p-10 text-center" data-testid="gallery-error">
            <p className="text-body">We could not load the gallery right now. Please try again shortly.</p>
          </div>
        )}

        {!loading && !error && items.length === 0 && (
          <div className="neu-panel p-10 text-center" data-testid="gallery-empty">
            <p className="text-body">New imagery is on its way. Please check back soon.</p>
          </div>
        )}

        {!loading && !error && items.length > 0 && (
          <div className="masonry-grid" data-testid="gallery-masonry">
            {items.map((item, i) => (
              <Reveal key={item.id} delay={(i % 6) * 60} className="masonry-item neu-surface overflow-hidden">
                <img src={item.image_url} alt={item.title} className="w-full h-auto object-cover" loading="lazy" data-testid={`gallery-item-${item.id}`} />
                <div className="p-4">
                  <span className="text-small font-semibold" style={{ color: "var(--gg-ivory)" }}>{item.title}</span>
                  {item.category && <span className="eyebrow block mt-1" style={{ color: "var(--gg-muted-text)" }}>{item.category}</span>}
                </div>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default Gallery;
